<template>
  <div class="page-container">
    <div class="page-top">
      <img class="tag" @click="showDetail = true" src="@/static/images/okApp/02.png" />
      <img @click="registerNow" class="application-btn" src="@/static/images/okApp/btn_01.png" />
      <img src="@/static/images/activityCenter/hand.gif" class="hand-gif" />
    </div>

    <div class="content">
      <div class="content-01">
        <div class="product-01">
          <div class="product-btn-01" @click="showPopup1 = !showPopup1">查看活动产品</div>
          <div class="see-detail" @click="partakeDetail(0)">查看参与详情</div>
        </div>

        <div class="product-02">
          <div class="product-btn-02" @click="showPopup2 = !showPopup2">查看活动产品</div>
          <div class="see-detail" @click="partakeDetail(1)">查看参与详情</div>
        </div>
      </div>

      <div class="order-reward">
        <div class="container">
          <img class="title-img" src="@/static/images/okApp/06.png" />
          <div class="text">
            <span> 出单任意个险产品，且每单业绩<strong>大于1000元</strong>，按单数计算，每出一单，得<strong>58元红包</strong>。 </span>
          </div>
          <img class="contert-img" src="@/static/images/okApp/07.png" />
          <div class="see-detail" @click="partakeDetail(2)">查看参与详情</div>
        </div>
      </div>
      <div class="footer-text">* 最终解释权归梧桐树保险经纪有限公司所有</div>
      <div class="content-02">
        <img @click="registerNow" class="footer-btn" src="@/static/images/okApp/btn_02.png" />
      </div>
    </div>

    <van-popup v-model="showPopup1" position="bottom" round :style="{ height: '70.2%' }">
      <div class="popup-container">
        <div class="item">
          <span>富德生命鑫禧年年养老年金保险（C款）</span>
        </div>
        <div class="item">
          <span>复星联合康爱一生护理保险（荣耀版）</span>
        </div>
        <div class="item">
          <span>弘康金禧一生年金保险（2023版）</span>
        </div>
        <div class="item">
          <span>太保智相守终身护理保险产品</span>
        </div>
        <div class="item">
          <span>复星保德信星海赢家（虎啸版）养老年金保险</span>
        </div>
        <div class="item">
          <span>信泰如意致享养老年金保险</span>
        </div>
        <div class="item">
          <span>大家养老大盈之家2.0养老年金保险</span>
        </div>
        <div class="item">
          <span>弘康金玉满堂3.0终身寿险</span>
        </div>
        <div class="item">
          <span>中意一生中意终身寿险（分红型）</span>
        </div>
        <div class="item">
          <span>弘康利多多2号终身寿险</span>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showPopup2" position="bottom" round :style="{ height: '58%' }">
      <div class="popup-container">
        <div class="item">
          <span>信泰完美人生2024重大疾病保险</span>
        </div>
        <div class="item">
          <span>复星联合妈咪保贝（星礼版）少儿重大疾病保险</span>
        </div>
        <div class="item">
          <span>君龙小青龙2号少儿重大疾病保险计划（互联网）</span>
        </div>
        <div class="item">
          <span>复星联合康乐一生（易核版2.0）重大疾病保险</span>
        </div>
        <div class="item">
          <span>人保寿险i无忧2.0重大疾病保险（互联网专属）</span>
        </div>
        <div class="item">
          <span>信泰如意久久守护（2024）重大疾病保险</span>
        </div>
        <div class="item">
          <span>信泰如意人生无忧（2024）重大疾病保险</span>
        </div>
        <div class="item">
          <span>华贵大麦甜蜜家2023定期寿险</span>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showDetail" class="rule-popup" closeable>
      <div class="wrapper" @click.stop>
        <div class="rule detail">
          <div class="text">
            <img src="@/static/images/activityCenter/icon-left.png" alt="" />
            <span>规则详情</span>
            <img src="@/static/images/activityCenter/icon-right.png" alt="" />
          </div>
          <div class="contentInfo">
            <p v-html="rule" style="padding-left: 0"></p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import config from '@/api/common'; //公共变量
import dayjs from 'dayjs';
export default {
  data() {
    return {
      showDetail: false,
      detailInfo: {},
      rule: '<p>一、活动时间：<br/>2023年12月1日0点至2023年12月31日23点59分59秒<br/><br/>二、活动对象：<br/>OK保已签约代理人<br/><br/>三、活动参与：<br/>1、需报名活动才可发放，未报名无法统计奖励情况，奖励不予发放<br/>2、出单活动清单范围内的产品，且业绩达到标准。<br/>3、业绩计算按照标准保费计算规则:<br/>趸交:标准保费&nbsp;=&nbsp;保单保费&nbsp;X&nbsp;0.1<br/>交费期限3年期:标准保费&nbsp;=&nbsp;保单保费&nbsp;X&nbsp;0.3<br/>交费期限5年期:标准保费&nbsp;=&nbsp;保单保费&nbsp;X&nbsp;0.5<br/>交费期限10年期及以上:&nbsp;标准保费&nbsp;=&nbsp;保单保费&nbsp;X&nbsp;1<br/><br/>四、开单赢现金红包<br/>（一）活动内容<br/>年金终寿分红阶梯最高赢100g金条<br/>活动产品:指定年金分红及增额终身寿产品<br/>(1)累计业绩满2万，奖励388元<br/>(2)累计业绩满10万，&nbsp;奖励1088元<br/>(3)累计业绩满30万，奖励5888元<br/>(4)累计业绩满100万，奖励100g金条<br/>重疾定寿阶梯最高赢1088<br/>活动产品:指定重疾以及定寿产品<br/>(1)累计业绩满1万，奖励188元<br/>(2)累计业绩满3万，奖励588元<br/>(3)累计业绩满5万，奖励1088元<br/>（二）活动产品<br/>富德生命鑫禧年年养老年金保险（C款）<br/>复星联合康爱一生护理保险（荣耀版）<br/>弘康金禧一生年金保险（2023版）<br/>太保智相守终身护理保险产品<br/>复星保德信星海赢家（虎啸版）养老年金保险<br/>信泰如意致享养老年金保险<br/>大家养老大盈之家2.0养老年金保险<br/>弘康金玉满堂3.0终身寿险<br/>中意一生中意终身寿险（分红型）<br/>弘康利多多2号终身寿险<br/>信泰完美人生2024重大疾病保险<br/>复星联合妈咪保贝（星礼版）少儿重大疾病保险<br/>君龙小青龙2号少儿重大疾病保险计划（互联网）<br/>复星联合康乐一生（易核版2.0）重大疾病保险<br/>人保寿险i无忧2.0重大疾病保险（互联网专属）<br/>信泰如意久久守护（2024）重大疾病保险<br/>信泰如意人生无忧（2024）重大疾病保险<br/>华贵大麦甜蜜家2023定期寿险<br/>（三）活动规则<br/>1、活动期间内，出单对应类别活动清单内的产品，累计业绩达标，可获得对应的现金奖励<br/>2、对应类别的累计业绩奖励仅以达成的最高门槛对应的奖励进行发放，不可重复获得。<br/>3、投保时间和承保时间都需要在活动期间内，在活动结束次月20日24点前成功通过质检、且签收回执、保单过犹过访，满足以上所有条件方可计入活动业绩。<br/>4、活动订单仅计算活动期间所出新单，不含追加、加保、续期订单。<br/>5、仅限第一位业绩达到要求者获得<br/><br/>五、单单有奖活动规则<br/>（一）活动内容<br/>出单任意个险产品，且每单业绩大于1000元，按单数计算&nbsp;&nbsp;每出一单，得58元红包。<br/>（二）活动规则&nbsp;<br/>1、活动期间，每出一单满足要求，得58元红包，多出多得。<br/>2、投保时间和承保时间都需要在活动期间内，在活动结束次月20日24点前成功通过质检、且签收回执、保单过犹过访，满足以上所有条件方可计入活动业绩。<br/>3、活动订单仅计算活动期间所出新单，不含追加、加保、续期订单。<br/>*注：单单有奖活动与开单赢现金红包活动分开计算，可兼得。<br/><br/>六、注意事项<br/>1、如遇退保，OK保将扣回此单所有推广费及所有奖励。<br/>2、如发现同一代理人活动期间退保率超过10%，OK保有权追回所有奖励。<br/>3、代理人奖励发放时，需满足平台业务品质要求。如不满足，平台有权不予发放奖励。OK保有权对业绩品质进行质检。<br/>4、参加活动要求个人继续率&nbsp;≥90%，且个人新单退保率&lt;5%，达标与否，将以活动开始前定版数据&nbsp;(即2023.11.30零点系统数据)&nbsp;为准。<br/>5、严禁恶意拆单，若发现多笔订单均为同一被保人、投保人、出单人、同一产品，则视为同一个订单，仅发放一次奖励。<br/>6、代理人若在奖励发放前离职，则奖励不予结算。<br/><br/>七、活动奖励发放<br/>1、现金奖励将会在活动结束后的次月20日之后进行发放。未回执回访，未完成质检单录，或产生退保的订单奖励不予结算。<br/>2、退保的情况下，业绩数据同步会有延迟，以活动结束后的最终核算业绩（扣除退保件等）为主，来进行奖励发放。<br/><br/>本活动最终解释权归梧桐树保险经纪有限公司所有<br/></p>',
      show: false,
      showPopup1: false,
      showPopup2: false,
      list: [],
      productionIds: ['1730103724286988290', '1730133568609636354', '1730136157015298050'],
      localIds: ['1740304969112977410', '1740304990235492354', '1753224057235881986']
    };
  },

  created() {
    this.getList();
  },

  methods: {
    getList() {
      this.$http({
        type: 'GET',
        url: '/app/merchantActivity/detailList',
        data: {
          idList: config.env == 1 ? this.productionIds.join(',') : this.localIds.join(',')
        }
      }).then(res => {
        this.list = res.data;
      });
    },

    registerNow() {
      this.$http({
        type: 'POST',
        url: '/app/merchantActivity/signup',
        data: {
          activityIds: config.env == 1 ? this.productionIds : this.localIds
        }
      }).then(res => {
        this.$notice.msg('报名成功');
      });
    },

    partakeDetail(index) {
      this.$router.push({
        path: '/apps/partakeList',
        query: {
          id: config.env == 1 ? this.productionIds[index] : this.localIds[index],
          type: this.list[index].type,
          calFactor: this.list[index].calFactor,
          productType: this.list[index].productType,
          mode: this.list[index].mode,
          status: this.list[index].status,
          conditionalIndicator: this.list[index].conditionalIndicator
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  .page-top {
    display: flex;
    flex-direction: column;
    height: 880px;
    background: url('../../../../static/images/okApp/01.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    .tag {
      position: absolute;
      right: 0;
      top: 20px;
      width: 140px;
      height: 50px;
    }
    .application-btn {
      width: 476px;
      height: 180px;
      margin: 0 auto;
      margin-top: auto;
      margin-bottom: -15px;
    }
    .hand-gif {
      width: 134px;
      position: absolute;
      right: 100px;
      bottom: -50px;
      z-index: 1;
    }
  }
  .content {
    position: relative;
    .content-01 {
      position: relative;
      width: 100%;
      height: 1277px;
      background: url('../../../../static/images/okApp/04.png') no-repeat;
      background-size: 100% 100%;

      .product-01 {
        position: absolute;
        top: 570px;
        width: 590px;
        left: 50%;
        margin-left: -295px;
        height: 80px;
        display: flex;
        justify-content: space-between;
        .product-btn-01 {
          width: 280px;
          height: 80px;
          border-radius: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #ff2800;
          font-size: 28px;
          color: #ff2800;
          font-weight: bold;
        }
        .see-detail {
          width: 280px;
          height: 80px;
          line-height: 80px;
          border-radius: 40px;
          background: linear-gradient(222deg, #fd8601 0%, #fc4901 100%);
          display: flex;
          justify-content: center;
          font-size: 28px;
          font-weight: bold;
          color: #fff;
        }
      }

      .product-02 {
        position: absolute;
        bottom: 80px;
        width: 590px;
        left: 50%;
        margin-left: -295px;
        height: 80px;
        display: flex;
        justify-content: space-between;
        .product-btn-02 {
          width: 280px;
          height: 80px;
          border-radius: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #ff2800;
          font-size: 28px;
          color: #ff2800;
          font-weight: bold;
        }
        .see-detail {
          width: 280px;
          height: 80px;
          line-height: 80px;
          border-radius: 40px;
          background: linear-gradient(222deg, #fd8601 0%, #fc4901 100%);
          display: flex;
          justify-content: center;
          font-size: 28px;
          font-weight: bold;
          color: #fff;
        }
      }
    }

    .order-reward {
      width: 100%;
      background: #ee2127;
      padding: 0 25px 30px 25px;
      .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: #fff;
        border-radius: 20px;
        .title-img {
          height: 120px;
        }
        .text {
          padding: 0 25px 30px 25px;
          span {
            font-size: 26px;
            color: #bb4b15;
          }
          strong {
            color: #ee2127;
          }
        }
        .contert-img {
          margin: 0 auto;
          height: 280px;
        }
        .see-detail {
          width: 280px;
          height: 80px;
          line-height: 80px;
          border-radius: 40px;
          background: linear-gradient(222deg, #fd8601 0%, #fc4901 100%);
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 36px;
          display: flex;
          justify-content: center;
          font-size: 28px;
          font-weight: bold;
          color: #fff;
        }
      }
    }

    .footer-text {
      background: #ee2127;
      text-align: center;
      font-size: 24px;
      color: #f9adae;
    }

    .content-02 {
      position: relative;
      width: 100%;
      height: 180px;
      background: #ee2127;

      .footer-btn {
        position: absolute;
        width: 100%;
        height: 160px;
        bottom: 0;
      }
    }
  }
  .popup-container {
    position: relative;
    background: url('../../../../static/images/okApp/popup_bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 118px 30px 41px 20px;
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 23px 0px;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 8px;
      margin-bottom: 10px;
      margin-left: 10px;
      span {
        padding: 0 0;
        margin: 0;
        font-size: 28px;
        color: #621d08;
        font-weight: bold;
      }
    }
  }
  .rule-popup {
    background-color: transparent;
    /deep/.van-popup__close-icon {
      top: 52px;
    }
  }
  .wrapper {
    width: 690px;
  }
  .rule {
    padding: 0 30px 10px;
    .contentInfo {
      max-height: 80vh;
      overflow-y: scroll;
    }
    p {
      font-size: 26px;
      color: #643d2e;
      padding-left: 42px;
      margin-top: 10px;
      margin-bottom: 30px;
    }
    /deep/table {
      border-collapse: collapse;
      td {
        border: 1px solid #643d2e;
      }
    }
  }
  .detail {
    background: #ffffff;
    border-radius: 16px;
    border: 0.053rem solid rgb(255, 225, 124);
    margin-top: 30px;
    padding: 0 25px;
    position: relative;
    z-index: 1;

    .text {
      width: 252px;
      height: 73px;
      background: linear-gradient(300deg, #fd9336 0%, #f97936 43%, #f45b37 100%);
      border-radius: 0px 0px 32px 32px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 34px;
      font-weight: 500;
      color: #ffffff;
      margin-top: -0.053rem;

      img {
        width: 30px;
        height: 25px;
      }

      span {
        margin: 0 10px;
      }
    }
  }
}
</style>
